import { PublicLayout } from "@/components/PublicLayout";
import { SectionHeading } from "@/components/shared";
import { UserPlus, Wallet, ListChecks, ShieldCheck, ArrowUpFromLine, Users } from "lucide-react";

const steps = [
  { icon: UserPlus, t: "1. Register", d: "Create your account with your full name, email and mobile number. Optionally enter a referral code." },
  { icon: Wallet, t: "2. Deposit", d: "Send USDT to the platform wallet on TRC20 or BEP20, then submit the amount, transaction hash and a payment screenshot." },
  { icon: ListChecks, t: "3. Review", d: "Our team reviews your deposit. Once approved, your balance is credited server-side and recorded in your transaction history." },
  { icon: ShieldCheck, t: "4. Verify (optional)", d: "Complete identity verification to enhance account security and unlock full account features." },
  { icon: ArrowUpFromLine, t: "5. Withdraw", d: "Request a withdrawal to your wallet address. Requests are reviewed before processing — funds are never sent automatically." },
  { icon: Users, t: "6. Refer & Earn", d: "Share your referral link. When a referred user's first deposit is approved, you receive a configurable reward." },
];

export default function HowItWorks() {
  return (
    <PublicLayout>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 pt-16 pb-20">
        <SectionHeading center eyebrow="How It Works" title="A simple, transparent flow"
          subtitle="From registration to withdrawal, every step is clear and every balance change happens securely on our servers." />
        <div className="space-y-5">
          {steps.map((s) => (
            <div key={s.t} className="glass glass-hover rounded-2xl p-6 flex gap-5 items-start">
              <div className="w-12 h-12 shrink-0 rounded-xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center">
                <s.icon className="w-6 h-6 text-cyan-300" />
              </div>
              <div>
                <h3 className="font-heading text-lg text-white mb-1">{s.t}</h3>
                <p className="text-sm text-slate-400 leading-relaxed">{s.d}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="glass rounded-2xl p-6 mt-8 border-amber-500/20">
          <p className="text-sm text-amber-200/80"><strong>Risk notice:</strong> Digital assets involve significant risk. AI TECHNOLOGY does not guarantee profit, income or withdrawals. Please review our Risk Disclosure before participating.</p>
        </div>
      </section>
    </PublicLayout>
  );
}
